import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import QuantityEditor from 'support/displays/inventory/QuantityEditor'
import useBaseNorm from 'pages/app/inventory/norms/use-base-norm'
import classNames from 'classnames'

export default function EditInventoryNormQuantity ({
  weekdayIndex,
  max = null,
  min = null,
  className,
  inventoryItemId,
  normAtDefault = 0,
  defaultNormOffset = 0,
  activeIndex = 100
}) {
  const normObjectKey = React.useMemo(() => {
    return ['globals.inventory.norms.by_item', inventoryItemId, weekdayIndex].join('.')
  }, [inventoryItemId, weekdayIndex])

  const [normObject, setNormObject] = useEnvValue(normObjectKey)
  const [internalValue, setInternalValue] = React.useState((normObject && normObject.norm_offset) ? normObject.norm_offset : parseFloat(defaultNormOffset))

  /* React.useEffect(() => {
    const nextInternalValue = parseFloat(defaultNormOffset)
    if (nextInternalValue !== internalValue) {
      setInternalValue(nextInternalValue)
    }
  }, [defaultNormOffset]) */

  React.useEffect(() => {
    if (normObject && normObject.norm_offset === null) {
      setInternalValue(0)
    }
  }, [normObject])

  const baseAtIndex = useBaseNorm(normAtDefault, activeIndex)
  React.useEffect(() => {
    const nextNormObject = {}
    // sadas
    nextNormObject.weekday = weekdayIndex
    nextNormObject.inventory_item_id = inventoryItemId
    nextNormObject.norm_offset = internalValue || 0

    if (inventoryItemId || (internalValue || normObject)) {
      setNormObject(nextNormObject)
    } else {
      setNormObject(null)
    }
  }, [internalValue, weekdayIndex, inventoryItemId])

  const handleChange = React.useCallback((val) => {
    const nextValue = val - baseAtIndex
    if (nextValue !== internalValue) {
      setInternalValue(nextValue)
    }
  }, [baseAtIndex, internalValue])

  const editorClassName = classNames(
    className,
    { yellow: internalValue && internalValue !== defaultNormOffset }, /// Edited - not saved
    { green: internalValue && internalValue === defaultNormOffset }, /// Edited - saved
    { red: !internalValue && defaultNormOffset } /// Deleted - not saved
  )

  return (
    <QuantityEditor
      value={internalValue + baseAtIndex}
      className={editorClassName}
      max={max}
      min={min}
      onChange={handleChange}
    />
  )
}
